module.exports = __webpack_public_path__ + "static/media/60002.23c82088.png";